export default __webpack_public_path__ + "static/media/green-tick.cc4d87c4.png";